import { useMemo } from 'react';
import { InfiniteData } from '@tanstack/react-query';

interface FlattenConfig<TFnData, TItem> {
  flattenFn?: (data: TFnData) => TItem[];
  totalFn?: (data: TFnData) => number;
}

export const useFlattenInfiniteData = <TFnData, TItem, TPageParam = unknown>(
  data: InfiniteData<TFnData, TPageParam> | undefined,
  {
    flattenFn = () => [],
    totalFn = () => 0,
  }: FlattenConfig<TFnData, TItem> = {},
): [TItem[], number] => {
  const flattenData = useMemo(
    () => data?.pages.flatMap(flattenFn) ?? [],
    [data, flattenFn],
  );

  const total = data && data.pages.length > 0 ? totalFn(data.pages[0]!) : 0;

  return [flattenData, total];
};
